import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators} from "@angular/forms";


@Component({
  selector: "app-brand-identification",
  templateUrl: "./brand-identification.component.html",
})
export class BrandIdentificationComponent implements OnInit, OnChanges {
  @Input() formTabData: any; // Input property to receive formData from the parent component
  currentDate: Date;
  dateFormat = "dd/MM/yyyy";
  brandIdentificationForm: FormGroup;
  nhanBietMarouOptions: string[] = ["Biết Đúng tên", "Biết mơ hồ", "Chưa biết"];
  bietCongTyQuaOptions: string[] = [
    "Nhà lên men",
    "Nhân viên công ty",
    "Hội thảo nông dân",
    "Chương trình cây giống",
    "Khác",
  ];
  camNhanVeSanPhamOptions: string[] = [
    "Tự hào về sản phẩm Marou",
    "Thích chất lượng sản phẩm",
    "Chưa trải nghiệm",
  ];
  nguonTraiNghiemSanPhamOptions: string[] = [
    "Quà tết",
    "Hội thảo",
    "Thăm hỏi",
    "Khác",
  ];
  yesNoOptions: string[] = ["Có", "Không"];
  constructor(private fb: FormBuilder) {}
  ngOnChanges(changes: SimpleChanges) {
    if (changes.formTabData && this.formTabData) {
      this.buildForm();

      try {
        if (this.formTabData.nhanDienThuongHieu) {
          const trimmedJsonString = this.formTabData.nhanDienThuongHieu.trim();

          const brandIdentificationData = JSON.parse(trimmedJsonString);

          if (brandIdentificationData) {
            // Check if brandIdentificationData is defined
            this.setFormValues(
              this.brandIdentificationForm,
              brandIdentificationData.brandIdentificationForm
            );
          }
        }
      } catch (error) {
        console.error("Error parsing JSON data:", error);
        // Handle the error or provide appropriate fallback behavior
      }
    }
  }

  private setFormValues(formGroup: FormGroup, data: any): void {
    for (const controlName in data) {
      if (data.hasOwnProperty(controlName)) {
        const control = formGroup.get(controlName);
        if (control) {
          control.setValue(data[controlName]);
        }
      }
    }
  }
  ngOnInit() {
    this.currentDate = new Date();
    this.buildForm();
    this.brandIdentificationForm
      .get("bietCongTyQua")
      .valueChanges.subscribe((selectedOption) => {
        if (selectedOption !== "Khác") {
          // Reset the custom input value when 'Khác' is not selected
          this.brandIdentificationForm.get("customBietCongTyQua").setValue(null);
        }
      });

    this.brandIdentificationForm
      .get("nguonTraiNghiemSanPham")
      .valueChanges.subscribe((selectedOption) => {
        if (selectedOption !== "Khác") {
          // Reset the custom input value when 'Khác' is not selected
          this.brandIdentificationForm.get("customNguonTraiNghiemSanPham").setValue(null);
        }
      });
  }

  buildForm() {
    this.brandIdentificationForm = this.fb.group({
      ngayGhiNhan: [this.currentDate, Validators.required],
      nhanBietMarou: [null, Validators.required],
      bietCongTyQua: [null],
      customBietCongTyQua: [null],
      camNhanVeSanPham: [null],
      nguonTraiNghiemSanPham: [null],
      customNguonTraiNghiemSanPham: [null],
      themTruongNguonTraiNghiemSanPham: [""],
      nhanVienGioiThieuCongTy: [null, Validators.required],
    });
  }

  private serializeFormGroup(formGroup: FormGroup): any {
    const serialized = {};
    for (const controlName in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(controlName)) {
        serialized[controlName] = formGroup.get(controlName).value;
      }
    }
    return serialized;
  }
  submitForm() {
    if (!this.brandIdentificationForm.value.nhanBietMarou || this.brandIdentificationForm.value.nhanBietMarou === '') {
      this.brandIdentificationForm.get('ngayGhiNhan').setValue(null);
    }
    const formData = {
      brandIdentificationForm: this.serializeFormGroup(this.brandIdentificationForm),
    };

    return formData;
  }

  getValidationStatus(controlName: string, yourForm: FormGroup): string {
    const control = yourForm.get(controlName);
    return  control.invalid ? 'error' : '';
  }
}
